"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Userlogin = function Userlogin(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "UserloginTitle UserloginDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "UserloginTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "UserloginDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M12.41 15.16l2.285-2.285H2.625a.6.6 0 0 1-.44-.186A.6.6 0 0 1 2 12.25a.617.617 0 0 1 .625-.625h12.031L12.41 9.359a.567.567 0 0 1-.195-.44c0-.175.065-.321.195-.439a.556.556 0 0 1 .43-.195.62.62 0 0 1 .45.195l3.69 3.79-3.69 3.789a.89.89 0 0 1-.216.127.605.605 0 0 1-.234.048.605.605 0 0 1-.235-.048.597.597 0 0 1-.195-.127.617.617 0 0 1-.195-.45c0-.169.065-.319.195-.449zm8.34-12.91c.352 0 .648.12.889.361.24.241.361.537.361.889V21c0 .352-.12.648-.361.889-.241.24-.537.361-.889.361H9.5c-.339 0-.632-.12-.879-.361A1.192 1.192 0 0 1 8.25 21v-5.645h1.27v4.883a.75.75 0 0 0 .214.537c.144.15.32.225.528.225h9.726a.733.733 0 0 0 .537-.225.733.733 0 0 0 .225-.537l-.02-15.976a.733.733 0 0 0-.224-.537.733.733 0 0 0-.537-.225h-9.707a.701.701 0 0 0-.528.225.75.75 0 0 0-.214.537v4.863H8.25V3.5c0-.352.124-.648.371-.889.247-.24.54-.361.879-.361h11.25z",
    id: "refUserloginPAyq-n5x_FJ"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refUserloginPAyq-n5x_FJ",
    fillRule: "evenodd"
  }));
};

Userlogin.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Userlogin.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Userlogin;
exports["default"] = _default;